const TableTemplateBody = (v: any)=>{
    return (
        `
        <table style="width:100%; border-collapse:collapse; font-family:Arial; font-size:12px; text-align:left;">
        <tr>
            <td style="width:25%; text-align:center; vertical-align:middle; border:1px dotted #999;">
            <img src="https://static.vecteezy.com/system/resources/previews/004/141/669/non_2x/no-photo-or-blank-image-icon-loading-images-or-missing-image-mark-image-not-available-or-image-coming-soon-sign-simple-nature-silhouette-in-frame-isolated-illustration-vector.jpg" 
            alt="Company Logo" style="max-width:100px;
            "/>
            </td>
            <td style="width:75%; text-align:center; vertical-align:middle; border:1px dotted #999;">
            <p><strong>[CompanyName]</strong></p>
            <p>(Co. No.: [CompanyRegNo])</p>
            <p>[CompanyAddress]</p>
            <p>[CompanyTIN]</p>
            <p>Tel No. [CompanyTelNo]</p>
            <p>SST NO: [CompanySSTNo]</p>
            <h3>${v.templateBody}</h3>
            </td>
        </tr>
        </table>

        <br />

        <table style="width:100%; border-collapse:collapse; font-family:Arial; font-size:12px; border:1px solid #000;">
        <thead>
            <tr style="background:#f0f0f0;">
            <th style="border:1px solid #000;">No</th>
            <th style="border:1px solid #000;">Account Code</th>
            <th style="border:1px solid #000;">Account Desc</th>
            <th style="border:1px solid #000;">Dept</th>
            <th style="border:1px solid #000;">Remark</th>
            <th style="border:1px solid #000;">Debit Amt</th>
            <th style="border:1px solid #000;">Credit Amt</th>
            </tr>
        </thead>
        <tbody>
            <tr>
            <td style="border:1px solid #000;">[Index]</td>
            <td style="border:1px solid #000;">[AccountCode]</td>
            <td style="border:1px solid #000;">[AccDesc]</td>
            <td style="border:1px solid #000;">[Dept]</td>
            <td style="border:1px solid #000;">[Remark]</td>
            <td style="border:1px solid #000;">[DebitAmt]</td>
            <td style="border:1px solid #000;">[CreditAmt]</td>
            </tr>
            <tr>
            <td colspan="5" style="text-align:left; border:1px solid #000; font-weight:bold;">Total Amount:</td>
            <td style="border:1px solid #000;font-weight:bold">[SumDebitAmt]</td>
            <td style="border:1px solid #000;font-weight:bold">[SumCreditAmt]</td>
            </tr>
        </tbody>
        </table>

        <br /><br />

        <table style="width:100%; border-collapse:collapse; font-family:Arial; font-size:12px; text-align:left;">
        <tr>
            <td style="width:33%; border:1px dotted #999; vertical-align:top; padding:6px;">
            <strong>Prepared By:</strong><br /><br />
            <div class="insert-text">[CreatedBy]</div><br />
            <strong>Date: [CreatedDate]</strong>
            </td>
            <td style="width:33%; border:1px dotted #999; vertical-align:top; padding:6px;">
            <strong>Submitted By:</strong><br /><br />
            <div class="insert-text">[SubmittedBy]</div><br />
            <strong>Date: [SubmittedDate]</strong>
            </td>
            <td style="width:33%; border:1px dotted #999; vertical-align:top; padding:6px;">
            <strong>Approved By:</strong><br /><br />
            <div>[ApprovedBy]</div><br />
            <strong>Date: [ApprovedDate]</strong>
            </td>
        </tr>
        </table>
        `
    )
}

export default TableTemplateBody;